import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { Apollo } from "apollo-angular";
import { GET_FOOTER_CATEGORIES_QUERY, GET_PAYMENT_TYPES_QUERY } from "./footer-themes.query";
import { BaseService, LanguageService } from "imakeapp-shared";





@Injectable({ providedIn: 'root' })
export class FooterThemesService extends BaseService
{





   constructor(
      private http: HttpClient,
      private cookie_s: CookieService,
      private apollo: Apollo,
      public override language_s: LanguageService
   ) {
     super(language_s);
   }

   get_static_pages()
   {
     return this.http.get(`${environment.ApiEndPoint2}/staticpages/index`);
   }

   get_footer_categories()
   {


    ;

     return this.apollo.watchQuery({
       query: GET_FOOTER_CATEGORIES_QUERY(this.lang),
       fetchPolicy: 'no-cache'
     }).valueChanges;

   }


   get_socials()
   {
     return this.http.get(`${environment.ApiEndPoint2}/socialUrls/index`);
   }


   get_payment_types()
   {


      return this.apollo.watchQuery({
         query: GET_PAYMENT_TYPES_QUERY(this.lang),
         fetchPolicy: "no-cache"
      }).valueChanges;

   }


}
